import { fetch } from "../../services";

export const userCourses = {};
